module.exports = __webpack_public_path__ + "img/018-graphic-design.a1056a6d.svg";